import React from "react"
import { SectionTitle, DataTable, StatusBadge } from "../components"
import { cardStyle, loadingStyle, emptyBoxStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { snakeToTitleCase } from "../utils/helpers"
import { TYPOGRAPHY } from "../constants/theme"

const PaymentTab = ({ payments, loading }) => {
	if (loading) {
		return (
			<div className="card-style" style={cardStyle}>
				<div style={loadingStyle}>กำลังโหลด...</div>
			</div>
		)
	}

	if (!payments || payments.length === 0) {
		return (
			<div className="card-style" style={cardStyle}>
				<SectionTitle title="ประวัติการชำระเงิน" />
				<div style={emptyBoxStyle}>
					<span>ไม่พบข้อมูลการชำระเงิน</span>
				</div>
			</div>
		)
	}

	const headers = ["วันที่สร้าง", "รหัสคำสั่งซื้อ", "แพ็คเกจ", "ราคา", "ช่องทางการชำระเงิน", "สถานะ", "ใบกำกับภาษี"]

	const rows = payments.map((payment) => [
		formatThaiBuddhistDate(payment.createdAt),
		payment.orderId,
		payment.plan ? (
			<div key="plan">
				{payment.plan.name || "-"}
				<br />
				<small>
					{formatThaiBuddhistDate(payment.plan.startAt)} - {formatThaiBuddhistDate(payment.plan.expiredAt)}
				</small>
			</div>
		) : (
			"-"
		),
		`${payment.price?.toLocaleString()} ฿`,
		payment.paymentMethod === "card" ? (
			<div>
				{payment.chargeResponse?.cardFinancing} Card
				<br />
				<small>
					({payment.chargeResponse?.cardBrand} ****{payment.chargeResponse?.cardLast4})
				</small>
			</div>
		) : (
			snakeToTitleCase(payment.paymentMethod) || "-"
		),

		<div key="status" style={{ maxWidth: 200 }}>
			<StatusBadge status={payment.status} />
			<br />
			<span style={{ color: "#333" }}>
				{formatThaiBuddhistDate(payment.status === "success" ? payment.successAt : payment.status === "failed" ? payment.failedAt : payment.expiredAt)}
			</span>
			{(payment.failureMessage || payment.failureCode) && (
				<>
					<br />
					<span style={{ fontSize: TYPOGRAPHY.fontSize.xs, color: "#888" }}>{payment.failureMessage || payment.failureCode}</span>
				</>
			)}
		</div>,
		payment.invoiceFile?.url ? (
			<a
				href={`${payment.invoiceFile.url}?token=${payment.invoiceFile.token}`}
				target="_blank"
				rel="noopener noreferrer"
				onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
			>
				<img src="/icons/icons8-download-32.png" alt="ดาวน์โหลด" style={{ width: "12px", height: "12px" }} />
				{payment.invoiceId}
			</a>
		) : (
			"-"
		),
	])

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="ประวัติการชำระเงิน" />
			<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลการชำระเงิน" />
		</div>
	)
}

export default PaymentTab
